(() => {
  if (customElements.get('camdeko-room-preview')) return;
  let modulePromise;
  customElements.define('camdeko-room-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.button = this.querySelector('button');
      this.button.addEventListener('click', async () => {
        this.button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        const status = this.querySelector('[role="status"]');
        status.textContent = '';
        try {
          if (!modulePromise) modulePromise = new Promise((resolve, reject) => {
            const timeout = setTimeout(() => reject(new Error('preview-timeout')), 15000);
            const done = () => { clearTimeout(timeout); resolve(); };
            const fail = error => { clearTimeout(timeout); reject(error); };
            const css = document.createElement('link');
            css.rel = 'stylesheet'; css.href = this.dataset.css;
            const cssReady = new Promise((ok, fail) => { css.onload = ok; css.onerror = fail; });
            document.head.append(css);
            const script = document.createElement('script');
            script.src = this.dataset.js;
            script.onload = () => cssReady.then(done, fail);
            script.onerror = fail;
            document.head.append(script);
          }).catch(error => { modulePromise = null; throw error; });
          await modulePromise;
          if (!this.controller) this.controller = new window.CamdekoRoom.Controller(this);
          await this.controller.open();
        } catch (error) { status.textContent = this.dataset.error; }
        finally { this.button.disabled = false; this.removeAttribute('aria-busy'); }
      });
    }
    disconnectedCallback() { this.controller?.destroy(); }
  });
})();
